import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2bd47b54")

_pushScopeId("data-v-2bd47b54")
const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = {
  ref: "iframeDom1",
  style: {"width":"100%","height":"100%"},
  src: "/perfetto_dist/index.html"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("iframe", _hoisted_2, null, 512),
    _withDirectives(_createVNode("h2", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.btn && _ctx.btn(...args)))
    }, "333", 512), [
      [_vShow, false]
    ])
  ]))
})